import { XHRRequestCanceler } from '../../Libs/xhr/XHRRequestCanceler';
import { BaseApiDataResponse } from '../Models/ApiData';
import {
    CompagnonDetails,
    CompagnonDetailsApiDataResponse,
    CompagnonListOrder,
    CompagnonListResponse,
    CompagnonRole,
    CompagnonSummaryListResponse,
} from '../Models/Compagnon/Compagnon';
import { BaseDataService } from './Base/BaseDataService';

export const CompagnonEndpoints = {
    COMPAGNONS_SUMMARY: '/api/v1/back/compagnons/summary',
    COMPAGNONS: '/api/v1/back/compagnons',
    COMPAGNON: (compagnonId: string) => `/api/v1/back/compagnons/${compagnonId}`,
    UPDATE_COMPAGNON: (compagnonId: string) => `/api/v1/back/compagnons/${compagnonId}`,
    CREATE_COMPAGNON: '/api/v1/back/compagnons',
    EXPORT_COMPAGNON_LIST: '/api/v1/back/compagnons/export',
};

export interface ICompagnonDataService {
    getCompagnons: (
        params: {
            compagnon_role?: string;
            is_active?: boolean;
            search?: string;
            Count?: number; // ! Count n'est pas un paramètre obligatoire
            have_front_access?: boolean;
            order?: CompagnonListOrder;
        },
        cts: XHRRequestCanceler
    ) => Promise<CompagnonListResponse>;

    listCompagnonSummary: (
        params: {
            search?: string;
            role?: CompagnonRole;
        },
        cts: XHRRequestCanceler
    ) => Promise<CompagnonSummaryListResponse>;

    getCompagnon: (
        cts: XHRRequestCanceler,
        compagnonId: string
    ) => Promise<CompagnonDetailsApiDataResponse>;

    updateCompagnon: (
        compagnonId: string,
        compagnon: CompagnonDetails,
        cts: XHRRequestCanceler
    ) => Promise<BaseApiDataResponse>;

    createCompagnon: (
        compagnon: CompagnonDetails,
        cts: XHRRequestCanceler
    ) => Promise<CompagnonDetailsApiDataResponse>;
}

class CompagnonDataService extends BaseDataService implements ICompagnonDataService {
    listCompagnonSummary = (
        params: { search?: string | undefined; role?: CompagnonRole },
        cts: XHRRequestCanceler
    ): Promise<CompagnonSummaryListResponse> => {
        return this.get<CompagnonSummaryListResponse>(CompagnonEndpoints.COMPAGNONS_SUMMARY, cts, {
            params,
        });
    };

    getCompagnons = async (
        params: {
            compagnon_role?: string;
            is_active?: boolean;
            search?: string;
            Count?: number; // ! Count n'est pas un paramètre obligatoire
            have_front_access?: boolean;
            order?: CompagnonListOrder;
        },
        cts: XHRRequestCanceler
    ) => {
        return this.get<CompagnonListResponse>(CompagnonEndpoints.COMPAGNONS, cts, {
            params,
        });
    };

    getCompagnon = async (cts: XHRRequestCanceler, compagnonId: string) => {
        return this.get<CompagnonDetailsApiDataResponse>(
            CompagnonEndpoints.COMPAGNON(compagnonId),
            cts
        );
    };

    updateCompagnon = async (
        compagnonId: string,
        compagnon: CompagnonDetails,
        cts: XHRRequestCanceler
    ) => {
        const body = {
            ...compagnon,
        };
        return this.patch(CompagnonEndpoints.UPDATE_COMPAGNON(compagnonId), body, cts);
    };

    createCompagnon = async (compagnon: CompagnonDetails, cts: XHRRequestCanceler) => {
        const body = {
            ...compagnon,
        };
        return this.post<CompagnonDetailsApiDataResponse>(
            CompagnonEndpoints.CREATE_COMPAGNON,
            body,
            cts
        );
    };
}

const CompagnonDataServiceName = 'CompagnonDataService';
export { CompagnonDataService, CompagnonDataServiceName };
